import { useState } from "react";

import { IndicatorWrapper, Halo, Dot } from "./styles";

interface IExtensionPromotionIndicatorProps {
    isCollapsed: boolean;
}

export const ExtensionPromotionIndicator = ({ isCollapsed }: IExtensionPromotionIndicatorProps) => {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) {
        return null;
    }

    return (
        <IndicatorWrapper
            data-automation="extension-promotion-indicator"
            $isCollapsed={isCollapsed}
        >
            <Halo />
            <Dot onAnimationEnd={() => setIsVisible(false)} />
        </IndicatorWrapper>
    );
};
